import { create } from 'zustand';
import api from '../api/client';

export const useAuthStore = create((set) => ({
  token: localStorage.getItem('sa_token') || null,
  user: JSON.parse(localStorage.getItem('sa_user') || 'null'),
  loading: false,
  error: null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const { data } = await api.post('/auth/login', { email, password });

      // Gate: must be super admin
      if (!data.user.is_super_admin) {
        set({ loading: false, error: 'Access denied. Super admin privileges required.' });
        throw new Error('Access denied. Super admin privileges required.');
      }

      localStorage.setItem('sa_token', data.token);
      localStorage.setItem('sa_user', JSON.stringify(data.user));
      set({ token: data.token, user: data.user, loading: false });
      return data;
    } catch (err) {
      const error = err.message || err.response?.data?.error || 'Login failed';
      set({ loading: false, error });
      throw new Error(error);
    }
  },

  logout: () => {
    localStorage.removeItem('sa_token');
    localStorage.removeItem('sa_user');
    set({ token: null, user: null });
  },
}));
